import {normalizePhone} from 'goodeggs-formatters';

export default function validatePhone(phoneNumber?: string | null): boolean {
  return /^\+1\d{10}$/.test(normalizePhone(phoneNumber));
}

export function validatePhoneWithE164Format(phoneNumber?: string | null): boolean {
  // e164Pattern = /^\+[1-9]\d{1,14}$/;
  return (
    Boolean(phoneNumber?.startsWith('+')) && /^\+[1-9]\d{1,14}$/.test(normalizePhone(phoneNumber))
  );
}

export function formatDisplayPhone(value: string): string {
  if (!value) return '';
  if (value === '+') return '+';

  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';

  const hasUSCountryCode = digits.startsWith('1');
  const offset = hasUSCountryCode ? 1 : 0;

  const area = digits.slice(0 + offset, 3 + offset);
  const mid = digits.slice(3 + offset, 6 + offset);
  const last = digits.slice(6 + offset, 10 + offset);

  let formatted = '+1';

  if (area) formatted += ` (${area}`;
  if (area.length === 3) formatted += ')';
  if (mid) formatted += ` ${mid}`;
  if (last) formatted += `-${last}`;

  return formatted.trim();
}
